import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { formatPrice, parsePrice } from '@/services/formatter';

import type { CreateAutoCreditProps } from '../../../types/form-types';
import type { StockBoundElementType } from '../../../types/products';

const useStockBoundChange = () => {
  const { control, getValues, setValue, trigger } =
    useFormContext<CreateAutoCreditProps>();
  const [stockBounds, initialPayment, costCar] = useWatch({
    control,
    name: ['stockBounds', 'initialPayment', 'costCar']
  });

  const [initFeeModal, setInitFeeModal] = useState<
    { value: string; stockUuid: string } | undefined
  >(undefined);

  const handleEuBankStock = (selectedStock: StockBoundElementType) => {
    if (!selectedStock.bank.includes('eu_bank') && !selectedStock.checked)
      return;

    const { costCar, initialPayment, proofInCome } = getValues();
    const initFeePercent =
      (parsePrice(String(initialPayment)) * 100) / parsePrice(String(costCar));

    let recommendedInitFee: string | null = null;
    if (selectedStock.name.includes('12') && initFeePercent < 20)
      recommendedInitFee = formatPrice(
        Math.ceil(parsePrice(String(costCar)) * 0.2)
      );

    if (selectedStock.name.includes('24')) {
      if (proofInCome && initFeePercent < 20)
        recommendedInitFee = formatPrice(
          Math.ceil(parsePrice(String(costCar)) * 0.2)
        );
      else if (!proofInCome && initFeePercent < 30)
        recommendedInitFee = formatPrice(
          Math.ceil(parsePrice(String(costCar)) * 0.3)
        );
    }

    if (selectedStock.name.includes('36') && initFeePercent < 50)
      recommendedInitFee = formatPrice(
        Math.ceil(parsePrice(String(costCar)) * 0.5)
      );

    if (recommendedInitFee)
      setInitFeeModal({
        value: recommendedInitFee,
        stockUuid: selectedStock.uuid
      });
  };

  // Проверка на изменение значений initialPayment и costCar
  useEffect(() => {
    const euBankSelected = stockBounds.find(
      (item) => item.bank.includes('eu_bank') && item.checked
    );
    if (!euBankSelected) return;
    handleEuBankStock(euBankSelected);
  }, [initialPayment, costCar]);

  const handleStockBoundChange = (uuid: string) => {
    const stockArrayHandler = structuredClone(getValues().stockBounds);
    const stockIndex = stockArrayHandler.findIndex(
      (stock) => stock.uuid === uuid
    );
    stockArrayHandler.forEach((stock, index) => {
      if (
        index !== stockIndex &&
        stock.bank === stockArrayHandler[stockIndex].bank
      )
        stock.checked = false;
    });

    stockArrayHandler[stockIndex].checked =
      !stockArrayHandler[stockIndex].checked;
    setValue('stockBounds', stockArrayHandler);
    setTimeout(() => trigger('stockBounds'), 0); // Выбиваем из потока

    handleEuBankStock(stockArrayHandler[stockIndex]);
  };

  return {
    initFeeModal,
    closeInitFeeModal: () => setInitFeeModal(undefined),
    handleStockBoundChange
  };
};

export default useStockBoundChange;
